import { mapState } from 'vuex';
export default {
    name: 'sharesocial',
    props: {
        url : String,
        message : String,
        title : String
    },

    data : function(){

        return {
            loading : false,

            networks : [{
                n : 'Email',
                icon : 'far fa-envelope',
                c : '#f82a53',
                id : 'email'
            },{
                n : 'Facebook',
                icon : 'fab fa-facebook-f',
                c : '#3b5999',
                id : 'facebook'
            },{
                n : 'Skype',
                icon : 'fab fa-skype',
                c : '#009EDC',
                id : 'skype'
            },{
                n : 'Telegram',
                icon : 'fab fa-telegram-plane',
                c : '#0088cc',
                id : 'telegram'
            },{
                n : 'Tumblr',
                icon : 'fab fa-tumblr',
                c : '#35465c',
                id : 'tumblr'
            },{
                n : 'Viber',
                icon : 'fab fa-viber',
                c : '#59267c',
                id : 'viber'
            },{
                n : 'VK',
                icon : 'fab fa-vk',
                c : '#45668e',
                id : 'vk'
            },{
                n : 'WhatsApp',
                icon : 'fab fa-whatsapp',
                c : '#075e54',
                id : 'whatsapp'
            }]
        }

    },

    components : {
    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {
        
    },
}